// Select 2
import 'select2/dist/js/select2.min.js'

// Set Bootstrap 5 theme
$.fn.select2.defaults.set("theme", "bootstrap-5");

/* Initalize Select 2 automatically */
$(function () {
    "use strict";

    if ($('.select2').length > 0) {
        // Initialize all Select 2 elements 
        $(".select2").each(function () {
          let select2Tags = $(this).data('tags') ?? false;
          let select2Lang = $(this).data('lang') ?? 'en';
          let select2Max = $(this).data('max') ?? '0';

          /* Handling different languages */
          select2Lang = (['de', 'en', 'fr', 'es'].includes(select2Lang)) ? select2Lang : 'en';

          // Wrap and initalize
          $(this).wrap("<div class=\"position-relative\"></div>")
              .select2({
                  dropdownParent: $(this).parent(),
                  tags: select2Tags,
                  language: select2Lang,
                  maximumSelectionLength: select2Max,
                  width: '100%'
              }).on('select2:open', function() {
                $(this).parent().find('.select2-search__field').attr('aria-label', $(this).attr('aria-label') ?? $(this).attr('placeholder') ?? 'Search');
              });

          setTimeout(() => {
            $(this).parent('div').find('.select2-search__field').attr('aria-label', $(this).attr('aria-label') ?? $(this).attr('placeholder') ?? 'Search');
          }, 100);
        });
    }
});

jQuery(function($) {
    $.fn.select2.amd.require([
    'select2/selection/single',
    'select2/selection/placeholder',
    'select2/selection/allowClear',
    'select2/dropdown',
    'select2/dropdown/search',
    'select2/dropdown/attachBody',
    'select2/utils'
  ], function (SingleSelection, Placeholder, AllowClear, Dropdown, DropdownSearch, AttachBody, Utils) {
    let SelectionAdapter = Utils.Decorate(
      SingleSelection,
      Placeholder
    );

    SelectionAdapter = Utils.Decorate(
      SelectionAdapter,
      AllowClear
    );

    let DropdownAdapter = Utils.Decorate(
      Utils.Decorate(
        Dropdown,
        DropdownSearch
      ),
      AttachBody
    );

    let base_elements = $('.select2-multiple');

    base_elements.each(function() {
      let current_element = $(this);
      $(this).select2({
        selectionAdapter: SelectionAdapter,
        dropdownAdapter: DropdownAdapter,
        allowClear: true,
        templateResult: function (data) {

          if (!data.id) { return data.text; }

          let $res = $('<div></div>');

          $res.html('<span class="multicheck" aria-hidden="true"></span>' + data.text);
  
          return $res;
        },

        templateSelection: function (data) {
          if (!data.id) { return data.text; }
          let selected = (current_element.val() || []).length;
          let total = $('option', current_element).length;
          let result = selected + " / " + total;
          let translation = current_element.data('multiselect');
          if (translation !== undefined) {
              result = translation.replace('{selected}', selected).replace('{total}', total);
          }
          return result;
        }
      })
    })
  });
});